import Badge from "@common/controls/Badge/component";
import HelpIcon from "@common/controls/Icon/Help/component";
import Icon from "@common/controls/Icon/component";
import Preloader from "@common/controls/Preloader/component";
import { formatMoneyDisplay, formatNumberDisplay } from "@common/lib/format";
import { isNull, isUndefined } from "lodash";
import * as React from "react";

type ProfileWidgetKpiItemProps = {
  contentColor?: string | null;
  help?: string;
  isLoading?: boolean;
  label: string;
  onClick?: () => void;
  value: () => any;
  valueHelp?: string;
};
const KpiItemBase = (props: ProfileWidgetKpiItemProps) => (
  <li className="item" onClick={props.onClick}>
    <span className="content">
      <span>{props.label}</span>
      {!!props.help && <HelpIcon tooltip={props.help} />}
    </span>

    <span className="content" style={{ color: props.contentColor ?? undefined }}>
      {!!props.valueHelp && <HelpIcon tooltip={props.valueHelp} />}
      {props.isLoading ? <Preloader isFontSize relative /> : props.value()}
    </span>
  </li>
);

type ProfileWidgetKpiItemPlainProps = Omit<ProfileWidgetKpiItemProps, "value"> & {
  currencyCode: string | null | undefined;
  value: number | string | null | undefined;
};
export const KpiPlainItem = ({ currencyCode, value, ...props }: ProfileWidgetKpiItemPlainProps) => {
  const rv = React.useCallback(
    () =>
      isNull(value) || isUndefined(value) ? null : (
        <span>
          {isNaN(+value) ? value : currencyCode ? formatMoneyDisplay(+value, currencyCode) : formatNumberDisplay(value)}
        </span>
      ),
    [currencyCode, value]
  );
  return <KpiItemBase {...props} value={rv} />;
};

type ProfileWidgetKpiIconItemProps = Omit<ProfileWidgetKpiItemProps, "value"> & {
  color?: string | null;
  icon: string;
  value?: number | string | null;
};
export const KpiIconItem = ({ color, icon, value, ...props }: ProfileWidgetKpiIconItemProps) => {
  const rv = React.useCallback(
    () =>
      !!value && (
        <>
          {!!icon && <Icon icon={icon} />}
          <span>{value}</span>
        </>
      ),
    [icon, value]
  );
  return <KpiItemBase {...props} contentColor={color} value={rv} />;
};

type ProfileWidgetKpiBadgeItemProps = Omit<ProfileWidgetKpiItemProps, "value"> & {
  color: string;
  value: number | string | null | undefined;
};
export const KpiBadgeItem = ({ color, value, ...props }: ProfileWidgetKpiBadgeItemProps) => {
  const rv = React.useCallback(() => !!value && <Badge color={color}>{value}</Badge>, [color, value]);
  return <KpiItemBase {...props} value={rv} />;
};
